import { render, staticRenderFns } from "./OrderSignatureSheetsCard.vue?vue&type=template&id=5427048c"
import script from "./OrderSignatureSheetsCard.vue?vue&type=script&lang=js"
export * from "./OrderSignatureSheetsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports